import { Image6 } from "./image6";
import React from "react";

export const Gallery6 = (props) => {
  return (
    <div id="Youtube_thumbnails" className="text-center">
      <div className="container">
        <div className="section-title">
          <br></br><br></br>
          <h1>Rolex Thumbnail</h1>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title6}-${i}`}
                    className="col-sm-6 col-md-3 col-lg-4"
                  >
                    <Image6
                      title6={d.title6}
                      largeImage6={d.largeImage6}
                      smallImage6={d.smallImage6}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
    
  );
};

